import React, { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import styled from 'styled-components';
import Tabs from '../../../components/Tabs';
import useCreateAdminAccount from '../../../views/account/admin/common/hook/query/useCreateAdminAccount';

import PageTemplate from '../../../components/template/PageTemplate';
import AdminFormNavbar from '../../../views/account/admin/form/AdminFormNavbar';
import AccountAdminCreateForm from '../../../views/account/admin/form/AccountAdminCreateForm';

import PermissionTable from '../../../views/account/admin/list/PermissionTable';

import {
  ACCOUNT_ADMIN_PAGE_NAME,
  ACCOUNT_ADMIN_TAB_KEY,
  ACCOUNT_ADMIN_TAB_TITLE,
} from '../../../constants/service/app/accountAdminConstants';
import { FORM_DEFAULT_VALUE } from '../../../views/account/admin/common/constants';
import { AccountAdminCreateRequest, FormMode } from '../../../views/account/admin/common/types/AccountAdminFormType';
import { createFormValidationSchema } from '../../../views/account/admin/common/util/formValidationSchema';

import { onlyNum } from '../../../lib/utils';

const Form = styled.form`
  width: 100%;
`;
const AccountAdminCreate = (): React.JSX.Element => {
  const methods = useForm<AccountAdminCreateRequest>({
    mode: 'onChange',
    // TODO: npm => pnpm 의존성 변경 이후 타입 불일치가 감지돼 임시로 any 사용 수정 필요
    resolver: yupResolver(createFormValidationSchema) as any,
    defaultValues: FORM_DEFAULT_VALUE,
    resetOptions: {
      // keep dirty fields unchanged, but update defaultValues
      keepDirtyValues: true,
    },
  });

  const [currentTabKey, setCurrentTabKey] = useState(ACCOUNT_ADMIN_TAB_KEY.ADMIN_INFO);

  const { mutate: createAdminAccount, isLoading } = useCreateAdminAccount();

  const onSubmit = (data: AccountAdminCreateRequest) => {
    const { level, status, email, name, password, phone, permission } = data;
    const formAttachment = {
      level,
      status,
      email,
      name,
      password,
      // api에서 하이픈을 포함하면 에러 메시지가 전달되기때문에 숫자만 전달
      phone: onlyNum(phone),
      permission,
    };
    if (isLoading) {
      return;
    }
    createAdminAccount(formAttachment);
  };

  const onError = () => {
    setCurrentTabKey(ACCOUNT_ADMIN_TAB_KEY.ADMIN_INFO);
  };

  return (
    <PageTemplate pageName={ACCOUNT_ADMIN_PAGE_NAME.ADMIN_CREATE}>
      <FormProvider {...methods}>
        <Form id="account-admin-form" onSubmit={methods.handleSubmit(onSubmit, onError)}>
          <AdminFormNavbar mode={FormMode.CREATE} />
          <Tabs
            className="admin-create-tabs"
            onChange={(tabKey: number) => setCurrentTabKey(tabKey)}
            activeKey={currentTabKey}
            list={[
              {
                title: ACCOUNT_ADMIN_TAB_TITLE.ADMIN_INFO,
                content: <AccountAdminCreateForm />,
              },
              {
                title: ACCOUNT_ADMIN_TAB_TITLE.ADMIN_PERMISSION,
                content: <PermissionTable />,
              },
            ]}
          />
        </Form>
      </FormProvider>
    </PageTemplate>
  );
};

export default AccountAdminCreate;
